import { wrap } from 'svelte-spa-router/wrap';

import TermsConditions from './../TermsConditions.svelte';
import Home from './../Home.svelte';
import Exhibition from './../Exhibition.svelte';
import Submit from './../Submit.svelte';
import NotFound from './../NotFound.svelte';

const routes = {
  '/': wrap({ component: Home }),
  '/exhibition': wrap({ component: Exhibition }),
  '/terms-and-conditions': wrap({ component: TermsConditions }),
  '/submit': wrap({ component: Submit }),
  '*': wrap({ component: NotFound }),
};

export {
  routes
}
